import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './UserPage.css';
import MainNavbar from '../MainNavbar';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt } from 'react-icons/fa';
import { IoIosShareAlt } from 'react-icons/io';
import { MdPrint } from 'react-icons/md';
import { FaUserAlt, FaInfoCircle, FaUser, FaCheckCircle, FaUserSecret, FaHeart } from 'react-icons/fa';
import { faUserEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FiArrowRight } from 'react-icons/fi'; // or any arrow you like
import { GiCheckMark, GiCrossMark } from "react-icons/gi";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";
import { Dropdown } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { FaEllipsisV } from 'react-icons/fa';

const UserPage = () => {
    const { userId } = useParams();
    const [profiles, setProfiles] = useState([]);
    const [message, setMessage] = useState('');
    const [basicDetails, setBasicDetails] = useState({});
    const [personalDetails, setPersonalDetails] = useState({});
    const [partnerPreferences, setPartnerPreferences] = useState({});
    const navigate = useNavigate();
    const [accountCreationDate, setAccountCreationDate] = useState('');
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [followerCount, setFollowerCount] = useState(0);
    const [followingCount, setFollowingCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);
    const [hasPlan, setHasPlan] = useState(false);
    const [user, setUser] = useState(null);
    const [match, setMatch] = useState(null);
    const [showAllProfiles, setShowAllProfiles] = useState(false);
    const { showAlert } = useContext(AlertContext);
    const visibleProfiles = showAllProfiles ? profiles : profiles.slice(0, 5);
    const currentUser = JSON.parse(localStorage.getItem("user"));

    const profileCreatedByMapping = {
        'Myself': 'Profile created by me',
        'My Son': 'Profile created by parent',
        'My Daughter': 'Profile created by parent',
        'My Brother': 'Profile created by sibling',
        'My Sister': 'Profile created by sibling',
        'My Friend': 'Profile created by friend',
    };

    useEffect(() => {
        const fetchMatch = async () => {
            try {
                if (!userId) return;
                const res = await axios.get(`https://back.varankal.com/api/match/${userId}`, {
                    withCredentials: true,
                });
                setMatch(res.data);
            } catch (err) {
                console.error("Error fetching match:", err);
            }
        };

        fetchMatch();
    }, [userId]);

    useEffect(() => {
        if (!userId) return;  // okay to return *inside* useEffect

        const fetchUserById = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/auth/userpage/${userId}`);
                setUser(response.data);
            } catch (err) {
                console.error('Error fetching user:', err);
                setError('Failed to load user profile.');
            }
        };

        fetchUserById();
    }, [userId]);

    useEffect(() => {
        const checkPlan = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/user/view-profile/${userId}`, {
                    withCredentials: true,
                });
                if (response.data.profile) {
                    setHasPlan(true);
                }
            } catch (error) {
                setHasPlan(false); // No plan or error
            }
        };

        checkPlan();
    }, [userId]);





    // Function to fetch follow stats (follower count and following count)
    const fetchFollowStats = async (userId) => {
        try {
            const response = await axios.get(`https://back.varankal.com/user/follow-stats/${userId}`, {
                withCredentials: true,  // Ensure cookies are sent for session authentication
            });
            console.log("Follow stats:", response.data);
            setFollowerCount(response.data.followerCount);
            setFollowingCount(response.data.followingCount);
        } catch (error) {
            console.error("Error fetching follow stats:", error);
            setError('Failed to load follow stats.');
        }
    };

    useEffect(() => {
        if (userId) {
            fetchFollowStats(userId);
        }
    }, [userId]);


    useEffect(() => {
        document.body.classList.add('body-background');
        return () => {
            document.body.classList.remove('body-background');
        };
    }, []);

    useEffect(() => {
        const fetchBasicDetails = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/user/register-details/${userId}`, { withCredentials: true });
                setBasicDetails(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            }
        };

        const fetchPersonalDetails = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/user/personal-details/${userId}`, { withCredentials: true });
                setPersonalDetails(response.data);
                const createdAt = new Date(response.data.createdAt);
                const month = createdAt.toLocaleString('default', { month: 'long' });
                const year = createdAt.getFullYear();

                setAccountCreationDate(`${month} ${year}`);
            } catch (error) {
                console.error('Error fetching personal details:', error);
            }
        };

        const fetchPartnerPreferences = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/user/partnerpreferences/${userId}`, { withCredentials: true });
                setPartnerPreferences(response.data);
            } catch (error) {
                console.error('Error fetching partner preferences:', error);
            }
        };

        fetchBasicDetails();
        fetchPersonalDetails();
        fetchPartnerPreferences();
    }, [userId]);

    const handleShare = () => {
        const profileUrl = `https://varankal.com/userpage/${userId}`;

        if (navigator.share) {
            navigator
                .share({
                    title: 'Matrimony Profile',
                    text: 'Check out this profile on Matrimony Platform!',
                    url: profileUrl,
                })
                .then(() => console.log('Profile shared successfully'))
                .catch((error) => console.error('Sharing failed', error));
        } else {
            // Fallback for desktop browsers
            navigator.clipboard.writeText(profileUrl);
            showAlert('Profile link copied to clipboard!');
        }
    };

    const handlePrint = () => {
        if (!basicDetails) {
            console.error('Profile data is not available yet.');
            return; // Prevent print if profile is not available
        }

        const printContent = document.getElementById('profile-details'); // Get the profile section
        if (!printContent) {
            console.error('Profile details not found');
            return;
        }

        const newWindow = window.open('', '', 'width=600,height=400'); // Open a new window for printing
        newWindow.document.write('<html><head><title>Print Profile</title></head><body>');
        newWindow.document.write(printContent.innerHTML); // Copy profile content to new window
        newWindow.document.write('</body></html>');
        newWindow.document.close(); // Close the document
        newWindow.print(); // Trigger the print dialog
    };


    const allImages = [
        ...(basicDetails?.multipleImages || []),
        ...(basicDetails?.basicDetails?.profilePicture ? [basicDetails.basicDetails.profilePicture] : [])
    ];


    const goToNextImage = () => {
        if (currentImageIndex < allImages.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
        }
    };

    const goToPreviousImage = () => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex(currentImageIndex - 1);
        }
    };


    useEffect(() => {
        const fetchProfiles = async () => {
            try {
                // Hitting the correct backend route based on your setup
                const res = await axios.get('https://back.varankal.com/auth/suggested-profiles', {
                    withCredentials: true, // Ensures token in cookies is sent
                });

                if (res.data.message) {
                    setMessage(res.data.message);
                } else {
                    setProfiles(res.data);
                }
            } catch (err) {
                console.error('Error fetching profiles:', err);
                setMessage('Error fetching profiles');
            }
        };

        fetchProfiles();
    }, []);

    useEffect(() => {
        const container = document.querySelector('.profiles-scroll-container');
        if (!container) return; // ✅ Prevents null access

        const onWheel = (e) => {
            if (e.deltaY === 0) return;
            e.preventDefault();
            container.scrollLeft += e.deltaY;
        };

        container.addEventListener('wheel', onWheel);

        // Cleanup when unmounting
        return () => container.removeEventListener('wheel', onWheel);
    }, []);


    const handleProfileClick = (userId) => {
        if (!userId || userId === "undefined") {
            console.error("Invalid userId passed to handleProfileClick:", userId);
            return;
        }

        window.scrollTo(0, 0);
        navigate(`/userpage/${userId}`);
        console.log('handleprofile', userId);
    };
    const blockUser = async (blockedUserId) => {
        // Confirmation Swal
        Swal.fire({
            title: 'Block User?',
            text: "Are you sure you want to block this user?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, Block'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.post(
                        `https://back.varankal.com/auth/block/${blockedUserId}`,
                        { currentUserId: currentUser.userId },
                        { withCredentials: true }
                    );

                    Swal.fire(
                        'Blocked!',
                        'User has been blocked.',
                        'success'
                    ).then(() => {
                        navigate("/matchlist");
                    });

                } catch (error) {
                    console.error("Block error:", error);
                    Swal.fire('Error', 'Failed to block user', 'error');
                }
            }
        });
    };


    return (
        <>
            <MainNavbar />

            <div id="profile-details" className="containerww">
                <div className="profile-headerww">
                    <div className="profile-picww">
                        <div className="main-profile">
                            {allImages.length > 0 ? (
                                <>
                                    <img
                                        src={`data:image/jpeg;base64,${allImages[currentImageIndex]}`}
                                        alt={`Profile ${currentImageIndex + 1}`}
                                        className="profile-imageww78"
                                    />
                                    {allImages.length > 1 && (
                                        <>
                                            <button
                                                className="nav-arrow left"
                                                onClick={goToPreviousImage}
                                                disabled={currentImageIndex === 0}
                                            >
                                                &#60;
                                            </button>
                                            <button
                                                className="nav-arrow right"
                                                onClick={goToNextImage}
                                                disabled={currentImageIndex === allImages.length - 1}
                                            >
                                                &#62;
                                            </button>
                                            <div className="image-counter">
                                                {currentImageIndex + 1} of {allImages.length}
                                            </div>
                                        </>
                                    )}
                                </>
                            ) : (
                                <div className="placeholderww">No Profile Picture</div>
                            )}
                        </div>

                        <div className="created-by-line">
                            {user && (
                                <>
                                    <FontAwesomeIcon icon={faUserEdit} />
                                    <span>{profileCreatedByMapping[user.profileFor]}</span>
                                </>
                            )}
                        </div>

                        <div className='sharetoprofile44'>
                            <button onClick={handleShare} className="share-icon-btn44" title="Share Profile">
                                <IoIosShareAlt size={20} />
                            </button>
                            <button onClick={handlePrint} className="share-icon-btnnt44" title="Print Profile">
                                <MdPrint size={20} color="black" />
                            </button>
                        </div>
                    </div>

                    <div className="profile-infoww78">
                        <h2 className="profile-name-id" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <div>
                                <span className="profile-name">{basicDetails?.basicDetails?.name || 'User Name'}</span>
                                <span className="profile-id">({basicDetails?.customUserId || 'N/A'})</span>
                            </div>

                            <Dropdown align="end">
                                <Dropdown.Toggle
                                    variant="light"
                                    id="dropdown-basic"
                                    className="custom-dropdown-toggle"
                                >
                                    <FaEllipsisV />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() => blockUser(userId)}
                                        className="custom-dropdown-item-block"
                                    >
                                        Block User
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                        </h2>
                    </div>

                    <div className='mobile-only'>
                        <div className="profilebasicfff44">
                            <p>
                                <span className="label">Age</span>
                                <span className="colon">:</span>
                                <span className="value">
                                    {basicDetails?.basicDetails?.age ? `${basicDetails.basicDetails.age} Yrs` : 'N/A'}
                                </span>
                            </p>


                            <p><span className="label">Occupation</span><span className="colon">:</span><span className="value">{personalDetails.occupation || 'N/A'}</span></p>

                            <p><span className="label">Height</span><span className="colon">:</span><span className="value">{personalDetails.height ? `${personalDetails.height} Cm` : 'N/A'}</span></p>

                            <p><span className="label">Religion/Caste</span><span className="colon">:</span><span className="value">{personalDetails.religion && personalDetails.caste ? `${personalDetails.religion}/${personalDetails.caste}` : 'N/A'}</span></p>

                            <p><span className="label">Qualification</span><span className="colon">:</span><span className="value">{basicDetails.qualification || 'N/A'}</span></p>

                            <p><span className="label">Location</span><span className="colon">:</span><span className="value">{personalDetails.location?.district || 'N/A'}</span></p>
                        </div>

                    </div>
                    <div className='desktop-only'>
                        <div className="profilebasicfff44">
                            <p>
                                <span className="label">Age:</span>
                                <span className="value">
                                    {basicDetails?.basicDetails?.age ? `${basicDetails.basicDetails.age} Yrs` : 'N/A'}
                                </span>
                            </p>

                            <p><span className="label">Religion/Caste:</span><span className="value">{personalDetails.religion && personalDetails.caste ? `${personalDetails.religion}/${personalDetails.caste}` : 'N/A'}</span></p>
                            <p><span className="label">Location:</span><span className="value">{personalDetails.location ? personalDetails.location.district : 'N/A'}</span></p>
                        </div>
                    </div>




                    <div className="user-profile">
                        <div className="follow-stats-box">
                            <h5>Accepted: <span className="stat-number">{followerCount}</span></h5>
                        </div>
                        <div className="follow-stats-box">
                            <h5>Requested: <span className="stat-number">{followingCount}</span></h5>
                        </div>
                    </div>

                    <div className="emailphonenumberer">

                        {!hasPlan && ( // Only show Upgrade Now if user doesn't have a plan
                            <div className="upgrade-now-container">
                                <span className="upgrade-link" onClick={() => navigate('/subscription')}>
                                    Upgrade Now
                                </span>
                                <span className="view-details"> to view Contact</span>
                            </div>
                        )}

                        <div className="info-line">
                            <FaEnvelope className="iconon" />
                            <span className="spanemailup">
                                {basicDetails?.basicDetails?.email
                                    ? hasPlan
                                        ? basicDetails.basicDetails.email
                                        : `${basicDetails.basicDetails.email.split('@')[0].slice(0, 3)}...@${basicDetails.basicDetails.email.split('@')[1]}`
                                    : 'N/A'}
                            </span>
                        </div>

                        <div className="info-line">
                            <FaPhoneAlt className="iconon90" />
                            <span>
                                {basicDetails?.basicDetails?.phoneNumber
                                    ? hasPlan
                                        ? basicDetails.basicDetails.phoneNumber
                                        : `${basicDetails.basicDetails.phoneNumber.slice(0, -4)}XXXX`
                                    : 'N/A'}
                            </span>
                        </div>
                    </div>



                </div>
                <p className="date56789">
                    <FaCalendarAlt className="iconon" style={{ marginRight: '6px' }} />
                    {accountCreationDate}
                </p>

                <hr className='devifrdskds'></hr>



                <h2 className="suggestion-title">
                    <FiArrowRight style={{ marginRight: '6px', marginBottom: '-2px' }} />
                    New Matches for you
                </h2>


                <div className="profiles-scroll-container">
                    <div className="profiles-row">
                        {visibleProfiles.length > 0 ? (
                            visibleProfiles.map((profile, idx) => (
                                <div
                                    key={idx}
                                    className="profile-box-77"
                                    onClick={() => handleProfileClick(profile._id)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="profile-image-wrapper-77">
                                        <img
                                            src={`data:image/jpeg;base64,${profile.profilePicture}`}
                                            alt="Profile"
                                            className="profile-img-77"
                                        />
                                    </div>

                                    <div className="profile-details-77">
                                        <h4 className="profile-name-77">
                                            {profile.name}, {profile.age}
                                        </h4>
                                        <p className="profile-location-77">{profile.location}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p style={{ padding: "10px", color: "gray" }}>
                                No profiles found in your district.
                            </p>
                        )}
                    </div>
                </div>
                {profiles.length > 5 && (
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        <button
                            onClick={() => setShowAllProfiles(!showAllProfiles)}
                            className="view-all-btn77"
                        >
                            {showAllProfiles ? "Show Less" : "View All"}
                        </button>
                    </div>
                )}

                <div className="profile-sectionsww">
                    <div className="sectionww">
                        <h3><FaUserAlt style={{ marginRight: '8px', marginBottom: '-3px' }} /> About Me</h3>
                        <p className='abouttyyy'>{basicDetails?.basicDetails?.aboutMe || 'N/A'}</p>
                        <h3><FaInfoCircle style={{ marginRight: '8px', marginBottom: '-3px' }} /> Basic Details</h3>
                        <div className="details-gridww">
                            {/* Left Table */}
                            <table className="details-table67ww">
                                <tbody>
                                    <tr>
                                        <td><strong>Name</strong></td>
                                        <td>{basicDetails?.basicDetails?.name || 'Add Name'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Age</strong></td>
                                        <td>{basicDetails?.basicDetails?.age ? `${basicDetails.basicDetails.age} Yrs` : 'Add Age'}</td>
                                    </tr>

                                    <tr>
                                        <td><strong>Weight/Height</strong></td>
                                        <td>
                                            {personalDetails.weight || 'Add Weight'} / {personalDetails.height || 'Add Height'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Qualification</strong></td>
                                        <td>{basicDetails?.basicDetails?.qualification || 'Add Qualification'}</td>
                                    </tr>


                                    <tr><td><strong>Occupation</strong></td><td>{personalDetails.occupation || 'Add Occupation'}</td></tr>


                                </tbody>
                            </table>

                            {/* Right Table */}
                            <table className="details-table67ww">
                                <tbody>
                                    <tr><td><strong>Annual Income</strong></td><td>{personalDetails.userIncome || 'Add User Income'}</td></tr>


                                    <tr>
                                        <td><strong>Religion</strong></td>
                                        <td>{personalDetails?.religion || 'Not provided'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Caste</strong></td>
                                        <td>{personalDetails?.caste || 'Not provided'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Mother Tongue</strong></td>
                                        <td>{partnerPreferences.basic?.motherTongue || 'Add Mother Tongue'}</td>
                                    </tr>

                                    <tr>
                                        <td><strong>Location</strong></td>
                                        <td>{personalDetails.location ? `${personalDetails.location.state}, ${personalDetails.location.district}` : 'Location'}</td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>



                    <div className="sectionww">
                        <h3><FaUserSecret style={{ marginRight: '8px', marginBottom: '-3px' }} /> Personal Details</h3>
                        <div className="details-gridww">
                            {/* Left Table */}
                            <table className="details-tableww">
                                <tbody>
                                    <tr><td><strong>Father's Name</strong></td><td>{personalDetails.fatherName || 'Add Father\'s Name'}</td></tr>
                                    <tr><td><strong>Father's Occupation</strong></td><td>{personalDetails.fatherOccupation || 'Add Father\'s Occupation'}</td></tr>
                                    <tr><td><strong>Mother's Name</strong></td><td>{personalDetails.motherName || 'Add Mother\'s Name'}</td></tr>
                                    <tr><td><strong>Mother's Occupation</strong></td><td>{personalDetails.motherOccupation || 'Add Mother\'s Occupation'}</td></tr>
                                    <tr><td><strong>Number of Siblings</strong></td><td>{personalDetails.noOfSiblings || 'Nill'}</td></tr>
                                    <tr><td><strong>Family Class</strong></td><td>{personalDetails.familyClass || 'Add Family Class'}</td></tr>
                                    <tr><td><strong>Family Value</strong></td><td>{personalDetails.familyOrientation || 'Add Family Value'}</td></tr>

                                </tbody>
                            </table>

                            {/* Right Table */}
                            <table className="details-tableww">
                                <tbody>

                                    <tr><td><strong>Number of Brothers</strong></td><td>{personalDetails.noOfBrothers || 'Nill'}</td></tr>
                                    <tr><td><strong>Number of Sisters</strong></td><td>{personalDetails.noOfSisters || 'Nill'}</td></tr>

                                    <tr><td><strong>Complexion</strong></td><td>{personalDetails.complexion || 'Add Complexion'}</td></tr>
                                    <tr>
                                        <td><strong>Hobbies</strong></td>
                                        <td>{personalDetails.hobbies || 'Add Hobbies'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Interest</strong></td>
                                        <td>{personalDetails.interest || 'Add Interest'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Drinking Habits</strong></td>
                                        <td>{personalDetails.drinkingHabits || 'Add Drinking Habits'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Smoking Habits</strong></td>
                                        <td>{personalDetails.smokingHabits || 'Add Smoking Habits'}</td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div className="sectionww">
                        <h3><FaHeart style={{ marginRight: '8px', marginBottom: '-3px' }} /> Partner Preferences</h3>
                        <div className="preferences-sectionww">
                            <h4>About Partner</h4>
                            <p className="about-partnerrww">{partnerPreferences.about?.aboutMyPartner || 'Tell us about your partner'}</p>

                            <div className="preferences-gridww">
                                {/* Left Side - Basic Preferences */}
                                <div className="preferences-leftww">
                                    {/* <h4>Basic Preferences</h4> */}
                                    <table className="preferences-tableww">
                                        <tbody>
                                            {/* <tr>
                                                <td><strong>Age Range</strong></td>
                                                <td>{partnerPreferences.basic?.ageRange?.min || 'min'} - {partnerPreferences.basic?.ageRange?.max || 'max'}</td>
                                            </tr> */}
                                            <tr>
                                                <td><strong>Height</strong></td>
                                                <td>{partnerPreferences.basic?.height || 'Add Height'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Mother Tongue</strong></td>
                                                <td>{partnerPreferences.basic?.motherTongue || 'Add Mother Tongue'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Marital Status</strong></td>
                                                <td>{partnerPreferences.basic?.maritalStatus || 'Add Marital Status'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Qualification</strong></td>
                                                <td>{partnerPreferences.professional?.education || 'Add Qualification'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Profession</strong></td>
                                                <td>{partnerPreferences.professional?.employedIn || 'Add Profession'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Income</strong></td>
                                                <td>{partnerPreferences.professional?.annualIncome || 'Add Income'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Eating Habits</strong></td>
                                                <td>{partnerPreferences.basic?.eatingHabits || 'Add Eating Habits'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Drinking Habits</strong></td>
                                                <td>{partnerPreferences.basic?.drinkingHabits || 'Add Drinking Habits'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Smoking Habits</strong></td>
                                                <td>{partnerPreferences.basic?.smokingHabits || 'Add Smoking Habits'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Right Side - Religion & Location Preferences */}
                                <div className="preferences-rightww">
                                    <div className="preferences-boxww">
                                        {/* <h4>Religion Preferences</h4> */}
                                        <table className="preferences-tableww">
                                            <tbody>
                                                <tr>
                                                    <td><strong>Religion</strong></td>
                                                    <td>{partnerPreferences.religious?.religion || 'Add Religion'}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Caste</strong></td>
                                                    <td>{partnerPreferences.religious?.caste || 'Add Caste'}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Sub-Caste</strong></td>
                                                    <td>{partnerPreferences.religious?.subCaste || 'Add Sub-Caste'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="preferences-boxww">
                                        {/* <h4>Location Preferences</h4> */}
                                        <table className="preferences-tableww">
                                            <tbody>
                                                <tr>
                                                    <td><strong>State</strong></td>
                                                    <td>{partnerPreferences.location?.state || 'Add State'}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>District</strong></td>
                                                    <td>{partnerPreferences.location?.district || 'Add District'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="match-container-RL">
                    <h2 className="match-title-RL">💞 Match Comparison</h2>

                    {match?.targetUser ? (
                        <div className="match-card-RL">
                            {/* Profile Section */}
                            <div className="profiles-top-RL">
                                <div className="profile-wrapper-RL">
                                    <img
                                        src={
                                            match.targetUser.profilePicture
                                                ? `data:image/jpeg;base64,${match.targetUser.profilePicture}`
                                                : "/default-avatar.png"
                                        }
                                        alt={match.targetUser.name}
                                        className="profile-img-RL"
                                    />
                                    <p className="profile-name-RL">
                                        <FaUser /> {match.targetUser.name || "Profile Name"}
                                    </p>
                                    <span className="profile-label-RL">Her Preferences</span>
                                </div>

                                <div className="match-score-RL">
                                    You match <span>{match.matchCount}</span> / {match.totalCriteria} preferences
                                </div>

                                <div className="profile-wrapper-RL">
                                    <img
                                        src={
                                            match.loggedUser.profilePicture
                                                ? `data:image/jpeg;base64,${match.loggedUser.profilePicture}`
                                                : "/default-avatar.png"
                                        }
                                        alt={match.loggedUser.name}
                                        className="profile-img-RL"
                                    />
                                    <p className="profile-name-RL">
                                        <FaUser /> {match.loggedUser.name || "You"}
                                    </p>
                                    <span className="profile-label-RL">You</span>
                                </div>
                            </div>

                            {/* Match Details */}
                            <div className="match-details-RL">
                                {[
                                    "age",
                                    "religion",
                                    "caste",
                                    "height",
                                    "motherTongue",
                                    "maritalStatus",
                                    "occupation",
                                    "userIncome",
                                    "disability",
                                    "hobbies",
                                    "interest",
                                    "drinkingHabits",
                                    "smokingHabits",
                                    "horoscope",
                                ].map((key, idx) => {
                                    const loggedValue = match.loggedUser[key];
                                    const targetValue = match.targetUser[key];
                                    const isMatch =
                                        loggedValue && targetValue && loggedValue === targetValue;

                                    return (
                                        <div key={idx} className="detail-item-RL">
                                            <div className="detail-labels-RL">
                                                <small className="detail-label-RL">{key}</small>
                                            </div>
                                            <div className="detail-values-RL">
                                                <span className="detail-text-RL">{targetValue || "—"}</span>
                                            </div>
                                            <div
                                                className={`status-icon-RL ${isMatch ? "match-yes" : "match-no"
                                                    }`}
                                            >
                                                {isMatch ? <GiCheckMark /> : <GiCrossMark />}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <p className="loading-RL">Loading match details...</p>
                    )}
                </div>

            </div>
        </>
    );
};

export default UserPage;
